import mediator from "@tvg/mediator";
import { BaseEventProps, track } from "@tvg/amplitude";
import {
  MediatorEventType,
  EmptyMessageEventData,
  TabSelectEventData,
  LiveVideoEventData,
  RaceActiveBetsEventData
} from "./types";
import { EVENTS, LABELS } from "./constants";
import { COMMON_EVENT_NAMES } from "../../constants";

export default () => {
  mediator.base.subscribe(
    MediatorEventType.TAB_SELECT_FDR,
    (data: TabSelectEventData) => {
      track<BaseEventProps>(`${LABELS.MY_BETS_TAB} ${EVENTS.OPEN}`, {
        [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
        [BaseEventProps.EVENT_LABEL]: data?.payload?.selectedTab,
        [BaseEventProps.MODULE]: "my_bets"
      });
    }
  );

  mediator.base.subscribe(MediatorEventType.MODAL_CLOSE_FDR, () => {
    track<BaseEventProps>(`${LABELS.BETSLIP} ${EVENTS.CLOSE}`, {
      [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
      [BaseEventProps.EVENT_LABEL]: "bets",
      [BaseEventProps.MODULE]: "bets"
    });
  });

  mediator.base.subscribe(MediatorEventType.CONFIRM_DELETE_BET_FDR, () => {
    track<BaseEventProps>(`${LABELS.BET} ${EVENTS.DELETED}`, {
      [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
      [BaseEventProps.EVENT_LABEL]: LABELS.BET,
      [BaseEventProps.MODULE]: "upcoming bets"
    });
  });

  mediator.base.subscribe(
    MediatorEventType.EMPTY_MESSAGE,
    (data: EmptyMessageEventData) => {
      track<BaseEventProps>(EVENTS.NAVIGATED_TO, {
        [BaseEventProps.EVENT_CATEGORY]: "Navigation",
        [BaseEventProps.LINK_TEXT]: data?.payload?.buttonText,
        [BaseEventProps.MODULE]: data?.payload?.module,
        [BaseEventProps.LINK_URL]: data?.payload?.destinationUrl
      });
    }
  );

  mediator.base.subscribe(MediatorEventType.OPEN_FROM_FOOTER_FDR, () => {
    track<BaseEventProps>(`${LABELS.BETSLIP} ${EVENTS.OPEN}`, {
      [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
      [BaseEventProps.EVENT_LABEL]: "bets",
      [BaseEventProps.MODULE]: "footer"
    });
  });

  mediator.base.subscribe(
    MediatorEventType.OPEN_LIVE_VIDEO,
    (data: LiveVideoEventData) => {
      track<BaseEventProps>(EVENTS.NAVIGATED_TO, {
        [BaseEventProps.EVENT_CATEGORY]: "Navigation",
        [BaseEventProps.LINK_TEXT]: "watch",
        [BaseEventProps.MODULE]: "bets page",
        [BaseEventProps.LINK_URL]: data?.payload?.raceUrl
      });
    }
  );

  mediator.base.subscribe(MediatorEventType.RACE_ACTIVE_BETS_MODAL_OPEN, () => {
    track<BaseEventProps>(`${LABELS.RACE_CARD} ${EVENTS.OPEN}`, {
      [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
      [BaseEventProps.EVENT_LABEL]: "Race Active Bets",
      [BaseEventProps.MODULE]: "racecard"
    });
  });

  mediator.base.subscribe(
    MediatorEventType.RACE_ACTIVE_BETS_MODAL_CLOSE,
    () => {
      track<BaseEventProps>(`${LABELS.RACE_CARD} ${EVENTS.CLOSE}`, {
        [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
        [BaseEventProps.EVENT_LABEL]: "Race Active Bets",
        [BaseEventProps.MODULE]: "Race Active Bets"
      });
    }
  );

  mediator.base.subscribe(
    MediatorEventType.RACE_ACTIVE_BETS_MODAL_RETURN,
    (data: RaceActiveBetsEventData) => {
      const eventLabel = `${data?.payload?.trackName} - R${data?.payload?.raceNumber} - ${data?.payload?.mtp}`;
      track<BaseEventProps>(EVENTS.NAVIGATED_TO, {
        [BaseEventProps.EVENT_CATEGORY]: "Navigation",
        [BaseEventProps.LINK_TEXT]: eventLabel,
        [BaseEventProps.MODULE]: "Race Active Bets",
        [BaseEventProps.LINK_URL]: data?.payload?.destinationUrl
      });
    }
  );
};
